import { render, staticRenderFns } from "./CUSkeletonLoaderTableView.vue?vue&type=template&id=1ddb5b2b"
import script from "./CUSkeletonLoaderTableView.vue?vue&type=script&lang=ts"
export * from "./CUSkeletonLoaderTableView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports